import React from "react";
import "./Partner.css";
import ReactGA from  "react-ga4";

const handlePartnerBook_Now = () =>{
  ReactGA.gtag("event", "hp_services_clicked", {    
    event_category: "containBtn", 
    event_label: "Home_Page_UI",
    value: 1,
    service: "wash",
    button : "book_now"
  });
  window.location.href = "https://www.driveu.in/car-care";
}

function Partner() {
  return (
    <div className="Partner_MainDiv">
      {/* Container for Partner Text */}
      <div className="Partner_TextDiv">
        {/* Heading for Partner section */}
        <h2 className="Partner_Heading_text" style={{ lineHeight: "150%" }}>
          Doorstep Wash & Deep Cleaning
        </h2>

        {/* Content for Partner section */}
        <div className="Partner_content_text" style={{ marginTop: "1rem" }}>
          {/* Information about DriveU's service */}
          DriveU brings on-demand car cleaning to your doorstep with
          satisfaction guarantee. Now available in &nbsp;
          {/* Cities where the service is currently available */}
          <span style={{ color: "black", font: "bold" }}>
            Bengaluru, Hyderabad and Gurgaon
          </span>
          , coming soon to other cities.
        </div>

        {/* Button to Book Now (Desktop) */}
        <div onClick={handlePartnerBook_Now}>
          <button className="Partner_bookNow Book_Now_partner">Book Now</button>
        </div>

        {/* Button to Book Now (Mobile) */}
        <div onClick={handlePartnerBook_Now}>
          <button className="Partner_bookNowMobile Book_Now_partner">
            Book Now
          </button>
        </div>
      </div>

      {/* Container for CAR WASH Image */}
      <div className="Roadside_Assistance_Div">
        {/* Image displayed for CAR WASH */}
        <img
          src="https://ik.imagekit.io/driveu/Doorstep_Car_Cleaning_Cvd5H4EbR.png?ik-sdk-version=javascript-1.4.3&updatedAt=1675667352993"
          alt="door_step_wash"
          loading="lazy"
          className="RoadSideAssistence_Image"
        />
      </div>
    </div>
  );
}

export default Partner;
